import axios from 'axios';
import authHeader from './AuthHeader';
import { AppConstants } from '../constants/AppConstants';
import UserEntity from '../types/userEntity.type';
import UserSettingsEntity from '../types/userSettingsEntity.type';

class UserService {
  getAllComments() {
    return axios.get(AppConstants.API_URL + '/comments');
  }

  getUsersBoard() {
    return axios.get(AppConstants.API_URL + '/users', { headers: authHeader() });
  }

  getAdminsBoard() {
    return axios.get(AppConstants.API_URL + '/users/admins', { headers: authHeader() });
  }
  getModeratorsBoard() {
    return axios.get(AppConstants.API_URL + '/users/moderators', { headers: authHeader() });
  }
  getUsersSettingsBoard(userId: number) {
    return axios.get(AppConstants.API_URL + '/settings/get-user-settings?userId='+userId, { headers: authHeader() });
  }

  getUserBoard(userId: number) {
    return axios.get(AppConstants.API_URL + '/users/get-user?id='+ userId,  { headers: authHeader() });
  }

  updateUserBoard(userId: number | null | undefined, userEntity: UserEntity) {
    return axios.put(AppConstants.API_URL + '/users/' + userId, { data: userEntity, headers: authHeader()} );
  }
  updateUserSettings(userId: number, userSettingsEntity: UserSettingsEntity) {
    return axios.put(AppConstants.API_URL + '/update-user-settings?userId=' + userId, { data: userSettingsEntity, headers: authHeader() });
  }


  searchUser(keyword : string) {
    return axios.get(AppConstants.API_URL + '/users/search?keyword=' + keyword, {headers: authHeader()} );
  }


  getModeratorBoard() {
    return axios.get(AppConstants.API_URL + '/users/moderators', { headers: authHeader() });
  }

  getAdminBoard() {
    return axios.get(AppConstants.API_URL + '/users/admins', { headers: authHeader() });
  }

  updateRole(role: string , userId: number) {
    return axios.put(AppConstants.API_URL + '/users/update-role?role=' + role  + '&&id=' + userId, { headers: authHeader() });
  }
}

export default new UserService();